import React from 'react';
import { strings } from '../../../resources/strings';
import { Field, FieldType } from '../../../common-components/Field/Field';
import { Carrier } from '../../../models/Carrier';

export class FormShippingLineValues {
  code?: string;
  shippingLineId?: number;
}

interface IFormShippingLineProps {
  carriers?: Carrier[];
  values?: FormShippingLineValues;
  change: (values: FormShippingLineValues) => void;
}

const FormShippingLine: React.FC<IFormShippingLineProps> = ({
  carriers,
  values,
  change
}) => {

  const memoForm = React.useMemo(() => {
    return (
      <Field
          type={FieldType.Select}
          label={strings.Carrier}
          selectProps={{
              options: [ { code: '', name: '' }, ...(carriers || []) ],
              displayField: 'name',
              keyField: 'code'
          }}
          value={values?.code}
          change={(value) => changeValues({...(values||{}), code: value})}
          marginTop='0px'
      />
    );
  }, [carriers])

  return (
    <>
      {memoForm}
    </>
  );

  function changeValues(values: FormShippingLineValues) {
    change({...values});
  }
}

export { FormShippingLine };